import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[widget-host]',
    standalone: false
})
export class WidgetDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
